export const CONTACT_US = "contact/CONTACT_US";
export const CONTACT_US_SUCCESS = "contact/CONTACT_US_SUCCESS";
export const CONTACT_US_FAILURE = "contact/CONTACT_US_FAILURE";
export const RESET_CONTACT_US = "contact/RESET_CONTACT_US";



// WEBPACK FOOTER //
// ./src/store/contactUs/actionTypes.js